jQuery(function ($) {
    $(document).ready(function() {
        //open mobile menu 
        const menuIcon = $('#nav-menu-icon');
        const overlay = $('#nav-mobile-menu');
        menuIcon.on('click', function() {

            let header = document.querySelector('.header-wrapper');
            // get the position of the bottom of the header relative to scroll position of the top of the window
            let offset = header.getBoundingClientRect().top + header.offsetHeight;
            // calculate the height of the mobile menu and set it with inline css
            $('.navigation-mobile').css('height', 'calc(100vh - ' + offset + 'px)');

            $(this).toggleClass('close');
            overlay.toggleClass('overlay');

            let slideTime = 250;

            if ($(this).hasClass('close')) {
                $('.header-wrapper').toggleClass('stuck'); //set logo fixed
                $('.navigation-mobile').slideDown(slideTime, function() {
                    // Animation complete.
                    $('body, html').css('overflow', 'hidden'); //dont allow scrolling the body if menu is open
                });
            } else {
                $('.navigation-mobile').slideUp(slideTime, function() {
                    // Animation complete.
                    $('body, html').attr('style', ''); //allow scrolling the body again
                    $('.header-wrapper').toggleClass('stuck'); //set logo fixed
                });
            }

            removeGradient();
        });


        //open submenu on mobile
        $('.navigation-mobile .nav-open-level').on('click',function(e) {
            e.preventDefault();
            var $submenu = $(this).closest('li').find('.nav-level-2');
            $('.nav-level-2').not($submenu).slideUp();
            $('.nav-open-level').not(this).removeClass('open');
            $submenu.slideToggle();
            $(this).toggleClass('open');
        });

        /*
        $('.nav-main-link').on('click',function(e) {
            // Allow default behavior for nav-main-link
            // This will allow following the link when clicked
            e.stopPropagation();
        });
        */

        // don't follow the link in de main nav if it has children
        $('.menu-item-has-children .nav-main-link-level-1').on('click',function(e) {
            e.preventDefault();
        });


        
        //remove gradient @menu when hover link with submenu
        // user pointerenter instead of mouseenter so we can check if it's a mouse event or a touch event. 
        // Otherwise it will conflict with the click event.
        $('.menu-item-has-children').on('pointerenter',function(e) {
            if (e.pointerType === 'mouse') {
                removeGradient('remove');
                $(this).addClass('dropdown-open');
            }
        });

        $('.menu-item-has-children').on('mouseleave',function(e) {
            removeGradient('add');
            $(this).removeClass('dropdown-open');
        });

        $('.menu-item-has-children').on('click',function() {
            removeGradient('toggle');
            $(this).toggleClass('dropdown-open');
        });


        //open searchform
        $( '.header-search-icon' ).on('click',function() {
            $('.header-search-container').toggle();
            $('.header-search-close-icon').toggle();
            $('.header-search-open-icon').toggle();
            $('.header-search-input').focus();
            removeGradient();
        });

    });

    //remove gradient in menu
    function removeGradient(action = 'toggle') {
        if ($('.page-template-front-page').length) {
            if (action === 'toggle') {
                $('.header-wrapper').toggleClass('header-wrapper-gradient');
            }

            if (action === 'remove') {
                $('.header-wrapper').removeClass('header-wrapper-gradient');
            }

            if (action === 'add') {
                $('.header-wrapper').addClass('header-wrapper-gradient');
            }
        }
    }
});